/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateSession} from '../api'

export const useMutationUpdateSession = createReactQueryMutationHook('updateSession', updateSession)
